export const inviteSuccessMessage = 'Invite was successfully sent'
export const resendInviteFailMessage = 'Failed to resend invite'
export const resendInviteSuccessMessage = 'Invite was successfully re-sent'
export const copyInviteLinkSuccessMessage = 'The link is copied to clipboard'
export const copyInviteLinkFailMessage = 'The link is not copied to clipboard'
